export const REACT_QUERY_GOALS_ACCESS_CONTROL = {
  allTemplates: 'allTemplates',
  goalsFrequency: 'goalsFrequency',
  goalsConfigurations: 'goalsConfigurations',
};
